import $ from 'jquery'

const scripts = () => {
    const closeMenu = () => {
    $('.header li').removeClass('open');
    $('.body').removeClass('open');
    $('.body').attr('style', '');
    $('.navigation').css('left', - (getWidth() + 30));
    $('.overlay').attr('style', '');
    $('.navigation ul').each(function() {
      $(this).attr('style', '');
    });
  }

  const openMenu =  (link) => {
    const menuIndex = $(link).parent().data('index');
    const cssQuery = `.navigation #${menuIndex}`;

    resetMenu();
    $(`.navigation #${menuIndex}`).css('display', 'block').addClass('active-menu');
    $(link).parent().addClass('open');
    $('.body').addClass('open').css('height', getHeight());
    $('.content').css('max-height', getHeight());
    $('.navigation').css('left', '0');
    $('.overlay').css('opacity', '0.8');
  }

  const getHeight = () => {
    return $(window).height() - $('.header').height();
  }

  const getWidth = () => {
    return $('.navigation').width();
  }

  const getInnerWidth = () => {
    return $('.navigation .navigation-container').width();
  }
  
  const openMenuHere = (e) => {
    const link = $('.navigation li.active');
    resetMenu();
    if (link.length > 0) {
      activateParents(link);
    } else {
      openMenu($(`li[data-index="${$(e.target).data('page')}"] a`));
    }
  }

  const activateParents = (li, selfLaunched = false) => {

    if (selfLaunched) {
      li.parent().css('left', '0');
      li.parent().css('display', 'block' );
    } else {
      li.parent().css('display', 'block');
    }

    if(!li.hasClass('navigation-container')) {
      activateParents(li.parent().parent(), true);
    } else {
      $(`.navigation #${$('.navigation .active-menu').attr('id')}`).css('display', 'block').addClass('active-menu');
      $('.body').addClass('open').css('height', getHeight());
      $('.content').css('max-height', getHeight());
      $('.navigation').css('left', '0');
      $('.overlay').css('opacity', '0.8');
    }
  }

  const resetMenu = () => {
    $('.header li').removeClass('open');
    $(`.navigation ul`).css('display', 'none');
    $(`.navigation ul`).removeClass('active-menu'); 
  }

  const openMobileMenu = () => {
      $('#mobile-nav .navigation').addClass('open');
      $('.mobile-overlay').addClass('show');
      $('body').addClass('mobile-open');
      $('#mobile-nav .navigation-menu').scrollTop(0);
  }

  const closeMobileMenu = () => {
      $('#mobile-nav .navigation').removeClass('open');
      $('.mobile-overlay').removeClass('show');
      $('body').removeClass('mobile-open');
      $('#mobile-nav .navigation-menu').scrollTop(0);
  }

  const toggleMobileMenu = () =>  {
    if ($('body').hasClass('mobile-open')) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  }

    const activateMobileParents = (li, selfLaunched = false) => {

      // temporarily disable
/*         toggleMobileMenu();
        return false; */
      // end disable

      if (selfLaunched) {
        li.parent().css('left', '0');
        li.parent().css('display', 'block' );
      } else {
        li.parent().css('display', 'block');
      }

      if(!li.hasClass('navigation-container')) {
        activateMobileParents(li.parent().parent(), true);
      } else {
        toggleMobileMenu();
      }
    }

  const setupListeners = () => {
    closeMobileMenu();

    const height = getHeight();
    $('.body .navigation').css('height', getHeight());

    $('.header li a').each(function() {
      $(this).on('click', function(e) {
        e.preventDefault();
        if ($('.body').hasClass('open')) {
          if ($(e.target).parent().hasClass('open')) {
            window.location.href = `${window.location.origin}${$(e.target).parent().data('path')}`;
          } else {
            closeMenu();
            setTimeout(function() {
              openMenu(e.target);
            }, 300);
          }
        } else {
          openMenu(e.target);
        }
      });

      $('.body .overlay').on('click', function(e) {
        closeMenu();
      })

    });

    $('.body .navigation .close').on('click', function() {
      closeMenu();
    });

    $('.body .navigation .back').on('click', function (e){
      e.preventDefault();
      $(this).parent().parent().attr('style', '');

      if ($(this).parent().parent().parent().parent().parent().hasClass('navigation-container')) {
        $(this).parent().parent().parent().parent().css('left', '50%');
      } else {
        $(this).parent().parent().parent().parent().css('left', '100%');
      }

    });

    $('.navigation .arrow').on('click', function(e) {
      e.preventDefault();
      const id = $(this).parent().data('index');
      $(this).parent().parent().css('left', 0);
      $(`ul[data-parent="${id}"]`).css('display', 'block');
      $('.body .navigation-menu').scrollTop(0);
      $('html').scrollTop(0);
      $('#mobile-nav .navigation-menu').scrollTop(0);
    });

    $('#hamburger').on('click', function(e) {
      e.preventDefault();
      openMenuHere(e);
    })

    $('#mobile-nav .toggle').on('click', function(e) {
      e.preventDefault();

      const link = $('#mobile-nav li.active');

      if (link.length > 0) {
        activateMobileParents(link);
      } else {
        toggleMobileMenu();
      }
    });

    $('.mobile-overlay').on('click', function() {
      closeMobileMenu();
    });

    $('#mobile-nav .back').on('click', function (e){
      e.preventDefault();
      $(this).parent().parent().attr('style', '');

      if ($(this).parent().parent().parent().parent().parent().hasClass('navigation-container')) {
        $(this).parent().parent().parent().parent().css('left', '50%');
      } else {
        $(this).parent().parent().parent().parent().css('left', '100%');
      }
    });
  }
  setupListeners();
}

export default scripts;


// WEBPACK FOOTER //
// ./src/components/Header/scripts.js